import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCross16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 6.94 4.995 3.934l-1.06 1.061L6.938 8l-3.005 3.005 1.06 1.061L8 9.061l3.005 3.005 1.06-1.06L9.062 8l3.005-3.005-1.06-1.06z"
	})
});
const ForwardRef = forwardRef(SvgIconCross16);
export default ForwardRef;
